// extracted by mini-css-extract-plugin
export default {"label":"l3A7ln"};